/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {AnimationTimelineInstruction} from './animation_timeline_instruction';
export class ElementInstructionMap {
private _map = new Map<any, AnimationTimelineInstruction[]>();
/**
 * @param {?} element
 * @return {?}
 */
consume(element: any): AnimationTimelineInstruction[] {
    let /** @type {?} */ instructions = this._map.get(element);
    if (instructions) {
      this._map.delete(element);
    } else {
      instructions = [];
    }
    return instructions;
  }
/**
 * @param {?} element
 * @param {?} instructions
 * @return {?}
 */
append(element: any, instructions: AnimationTimelineInstruction[]) {
    let /** @type {?} */ existingInstructions = this._map.get(element);
    if (!existingInstructions) {
      this._map.set(element, existingInstructions = []);
    }
    existingInstructions.push(...instructions);
  }
/**
 * @param {?} element
 * @return {?}
 */
has(element: any): boolean { return this._map.has(element); }
/**
 * @return {?}
 */
clear() { this._map.clear(); }
}

function ElementInstructionMap_tsickle_Closure_declarations() {
/** @type {?} */
ElementInstructionMap.prototype._map;
}

